import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscIdea = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="88827E"
      d="M12 4a7 7 0 0 1 4 12.742V22H8v-2h6v-4.417a5 5 0 1 0-4 0V18H8v-1.258A7 7 0 0 1 12 4Z"
    />
    <path
      fill="88827E"
      d="M4 12H2v-2h2v2ZM22 12h-2v-2h2v2ZM19.828 4.414l-1.414 1.414L17 4.414 18.414 3l1.414 1.414ZM6.823 4.41 5.41 5.822 3.994 4.41 5.41 2.994 6.823 4.41Z"
    />
    <path fill="#88827E" d="M13 3h-2V1h2v2Z" />
  </svg>
);
export default SvgMiscIdea;
